import * as React from "react";
import { useEffect } from "react";
import { Typography } from "@mui/material";
import { PageContainer } from "#pages/PageContainer";
import { useAppDispatch, useAppSelector } from "#store";
import { useDispatch } from "react-redux";
import { listInterpretationsFromServer } from "../../store/interpretations";
import { ObjectTable } from "#common/ObjectTable";
import { H1 } from "#common/headings";
import { isDone } from "#/store/types";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { Interpretation } from "@inode/pilot-client-typescript-fetch";
import { generatePath } from "react-router";
import { Link } from "#common/Link";
import { Routes } from "#/config";
import { generateUrl } from "#components/App/routing/generateUrl";

// const columns = [
//     {field: 'id', headerName: 'ID', width: 90},
//     {
//         field: 'firstName',
//         headerName: 'First name',
//         width: 150,
//         editable: true,
//     },
//     {
//         field: 'lastName',
//         headerName: 'Last name',
//         width: 150,
//         editable: true,
//     },
//     {
//         field: 'age',
//         headerName: 'Age',
//         type: 'number',
//         width: 110,
//         editable: true,
//     },
//     {
//         field: 'fullName',
//         headerName: 'Full name',
//         description: 'This column has a value getter and is not sortable.',
//         sortable: false,
//         width: 160,
//         valueGetter: (params) =>
//             `${params.row.firstName || ''} ${params.row.l astName || ''}`,
//     },
// ];
export const InterpretationListingPage = () => {
    const interpretations: Interpretation[] = useAppSelector(state => {
        return Object.values(state.interpretations.interpretations)
            .filter(isDone)
            .map(o => o.payload);
    });
    const cols: GridColumns = React.useMemo<GridColumns>(() => {
        if (!interpretations || interpretations.length < 1) {
            return [];
        }
        const head = Object.keys(interpretations[0]) ?? [];
        return head.map(columnName => {
            return {
                field: columnName,
                headerName: columnName,
                type: "string",
                width: 110,
                editable: false,
                renderCell: params => {
                    if (columnName === "id") {
                        return (
                            <Link
                                to={generatePath(Routes.interpretation.path, {
                                    id: String(params.value),
                                })}
                            >
                                {String(params.value)}
                            </Link>
                        );
                    } else {
                        return params.value;
                    }
                },
            };
        }) as GridColumns;
    }, [interpretations]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listInterpretationsFromServer());
    }, []);

    return (
        <PageContainer>
            <H1>Interpretations</H1>
            <Typography variant={"body1"}>
                This listing merely shows what currently is saved in the
                database.
            </Typography>
            <div style={{ height: 800, width: "100%" }}>
                <DataGrid
                    columns={cols}
                    rows={interpretations}
                    rowHeight={40}
                />
            </div>
            {/*<ObjectTable*/}
            {/*    data={interpretations as unknown as Array<Record<string, unknown>>}*/}
            {/*/>*/}
        </PageContainer>
    );
};
